import { render, staticRenderFns } from "./lesson-manage.vue?vue&type=template&id=6baa4c9b&scoped=true"
import script from "./lesson-manage.vue?vue&type=script&lang=js"
export * from "./lesson-manage.vue?vue&type=script&lang=js"
import style0 from "./lesson-manage.vue?vue&type=style&index=0&id=6baa4c9b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa4c9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6baa4c9b')) {
      api.createRecord('6baa4c9b', component.options)
    } else {
      api.reload('6baa4c9b', component.options)
    }
    module.hot.accept("./lesson-manage.vue?vue&type=template&id=6baa4c9b&scoped=true", function () {
      api.rerender('6baa4c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/lesson-manage.vue"
export default component.exports